var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-notification",attrs:{"isClosable":_vm.isClosable}},[_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"space-between"}},[_vm._t("default"),_vm._v(" "),(_vm.isClosable)?_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }